module.exports = "../dist/frontend/icons/cards/gold.svg?2fd68e64a312eda3f047f2f11bd7f702";